const replacePlaceholders = (translationText, placeholders) =>
    Object.keys(placeholders).reduce(
        (translation, key) =>
            translation.replace(new RegExp(`%${key}%`, 'g'), placeholders[key]),
        translationText
    );

export default replacePlaceholders;
